import EditType from './EditType'

export default EditType



// WEBPACK FOOTER //
// ./src/components/Types/Edit/index.js